<template>
    <div class="right-content mx-auto my-auto w-50 otp-card">
        <OtpModal :isMain="true"></OtpModal>
    </div>
</template>
<script>
import OtpModal from "@/components/core/OtpModal.vue";
export default {
    name:'OtpComponent',
    components: {
        OtpModal
    },
}
</script>
<style scoped>

</style>